import { render, staticRenderFns } from "./InvalidVoucherComponent.vue?vue&type=template&id=b585a412&"
import script from "./InvalidVoucherComponent.vue?vue&type=script&lang=js&"
export * from "./InvalidVoucherComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports